<p>vehicle-type-field works!</p>
